import {FormikErrors} from 'formik';
import {TFunction} from 'i18next';
import isEmpty from 'lodash/isEmpty';
import {SetFieldValue} from '../../../../../shared/model/formik.model';
import {
  getInvalidFormError,
  VALIDATION_INDICATOR_FIELD
} from '../../../../../utils/step-form-utils/validation-schema/validation-schema-utils';
import {CustomersDataFormFields} from './customer-data-form.model';

export interface CustomerDataStepActions {
  setFieldValue: SetFieldValue;
  validateForm: (values?: CustomersDataFormFields) => Promise<FormikErrors<CustomersDataFormFields>>;
  persistValues: (values: CustomersDataFormFields) => Promise<void>;
}

/**
 * Saves the Customer data step as a draft whenever the form is structurally valid; missing required fields stay
 * for the backend to flag when the application is moved. The move validates the saved data, not the form, so moving
 * on (validate = true) is refused when a structural error kept the form from being saved.
 */
export const saveCustomerDataStep = async (values: CustomersDataFormFields,
                                           validate: boolean,
                                           {setFieldValue, validateForm, persistValues}: CustomerDataStepActions,
                                           t: TFunction): Promise<void> => {
  await setFieldValue(VALIDATION_INDICATOR_FIELD, validate, false);

  const structuralErrors = await validateForm({...values, [VALIDATION_INDICATOR_FIELD]: false});
  const isStructurallyValid = isEmpty(structuralErrors);
  if (isStructurallyValid) {
    await persistValues({...values, [VALIDATION_INDICATOR_FIELD]: false});
  }

  // Re-run requested mode so per-tab badges stay accurate.
  await validateForm({...values, [VALIDATION_INDICATOR_FIELD]: validate});

  if (validate && !isStructurallyValid) {
    return Promise.reject(getInvalidFormError(t));
  }
};
